export const baseUrl = 'https://api.spotify.com';
export const clientId = '62e1aea45c50460e89bbed218eabcb3a';

export const appConfig = {
  randomness: 50,
  minFollowers: 10000000,
  pool: 1,
  yearOffset: 5,
  genre: 'rap',
};
